import Vue from 'vue'
import Router from 'vue-router'
import Merchant from './modules/merchant/index.js'
import Integration from '@/pages/general/Integration.vue'
import BeDirectBookingGoogle from '@/pages/hotel/be/BeDirectBookingGoogle'
import CommunityIndex from '@/pages/community/'
import CommunityHome from '@/pages/community/Home'
import DevelopmentOnly from '@/pages/general/DevelopmentOnly'
import ClearDataLocal from '@/pages/general/ClearData'
import { applyResolvedTitle, BRAND_FALLBACK } from '../utils/titleService.js'
import { trackEvent } from '../utils/analytics.js'

const emptyView = {template: '<router-view></router-view>'}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/google-direct-booking',
      name: 'BeDirectBookingGoogle',
      component: BeDirectBookingGoogle,
      meta:{
        module_type: 'merchant-hotel-booking_engine',
        no_wrapper: true
      }
    },
    {
      path: '/integration',
      name: 'Integration',
      component: Integration
    },
    {
      path: '/community',
      component:CommunityIndex,
      children: [
        {
          path: '/:community_code/group',
          name: 'CommunityHome',
          component: CommunityHome,
          meta:{
            module_type: 'community',
            no_wrapper: true
          }
        },
      ]
    },
    {
      path: "/development",
      name: "DevelopmentOnly",
      component: DevelopmentOnly
    },
    {
      path: "/clear-data-guestaps-01",
      name: "ClearDataLocal",
      component: ClearDataLocal
    },
    ...Merchant
  ],
  mode: 'history'
})

function getDeepestRecord(to) {
  const m = to.matched || [];
  return m.length ? m[m.length - 1] : null;
}

router.beforeResolve(async (to, from, next) => {
  const deepest = getDeepestRecord(to);

  if (!deepest) {
    applyResolvedTitle({ router });
    return next();
  }

  const { meta } = deepest;
  const resolveInComponent = !!(meta && meta.resolveInComponent);  
  
  if(resolveInComponent) return next();
  
  const metaTitle = meta && meta.title;

  try {
    applyResolvedTitle({
      router,
      title: metaTitle ? metaTitle : null
    });
  } catch (e) {
    // graceful fallback
    const fallback = store.getters.getMerchant.name || BRAND_FALLBACK;
    applyResolvedTitle({
      router,
      title: fallback,
      useTemplate: false
    });
  }
  
  next();
  
});

router.afterEach((to, from) => {

  if (window.fbqReady) {
    Vue.prototype.$sendEventMetaConversionsAPI("PageView");
  } else {
    window.fbqQueue = []
    window.fbqQueue.push("PageView");
  }

  if (to.meta && to.meta.resolveInComponent) return;

  const pageTitle = document.title;
  if(pageTitle && pageTitle !== BRAND_FALLBACK){
    trackEvent('page_view', {to, from})
  }
  
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js